export default __webpack_public_path__ + "static/media/Picture3.cc246b2d.jpg";